import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export interface Game {
    id?: number;
    name: string;
    type: number;
    software_house: string;
    image: string;
}

export function gameBundles(
    state: { results: any[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case GamesActionTypes.GET_BUNDLES_SUCCESS:
            return action.payload.gameBundles;

        default:
            return state;
    }
}

export function gameBundlesLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case GamesActionTypes.GET_BUNDLES:
            return true;

        case GamesActionTypes.GET_BUNDLES_FAIL:
        case GamesActionTypes.GET_BUNDLES_SUCCESS:
            return false;

        default:
            return state;
    }
}
